import React from "react";

interface Props {
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
}

const HtmlView: React.FC<Props> = ({ value, onChange, disabled }) => {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={{
        width: "100%",
        height: "300px",
        fontFamily: "monospace",
        fontSize: "14px",
      }}
    />
  );
};

export default HtmlView;
